/*
 * Cotizador de envío Barradas.
 *
 * Reglas (snippets/shipping-checker-config.liquid, desde Tabulador_envio_km_barradas.xlsx):
 *   km <= freeRadiusKm                 -> Gratis: se paga en línea
 *   freeRadiusKm < km <= deliveryLimit -> Entrega Barradas: muestra km x ratePerKm + IVA y manda al vendedor
 *                                         por WhatsApp con el costo; no se paga en línea
 *   km > deliveryLimit / CP no hallado -> Fletera: cotizar con el vendedor por WhatsApp (no se paga en línea)
 *
 * El widget se inserta solo junto a los botones de compra; no depende de bloques ni de
 * secciones del tema, para que sobreviva a cambios o actualizaciones del tema.
 */
(() => {
  if (customElements.get('shipping-checker')) return;

  const settingsEl = document.getElementById('BarradasShippingConfig');
  if (!settingsEl) return;

  let SETTINGS;
  try {
    SETTINGS = JSON.parse(settingsEl.textContent);
  } catch (e) {
    console.error('shipping-checker: configuración inválida (revisa snippets/shipping-checker-config.liquid)', e);
    return;
  }

  const CONFIG = Object.assign(
    {
      freeRadiusKm: 40,
      deliveryLimitKm: 100,
      ratePerKm: 15,
      ivaRate: 0.16,
      bandKm: 0,
      whatsapp: '',
      title: 'Calcula tu envío',
      hint: ''
    },
    SETTINGS.config
  );
  // Respaldo incrustado (snippets/shipping-locations.liquid). Las ubicaciones vigentes vienen de la
  // API de gestión (getLocations); este respaldo se usa si la API no responde y para dar coordenadas
  // a ids que la API trae sin lat/lng.
  const FALLBACK_LOCATIONS = (SETTINGS.locations || []).filter((l) => typeof l.lat === 'number' && typeof l.lng === 'number');

  const STORAGE_KEY = 'barradas:shipping-check';
  const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  const NOMINATIM = 'https://nominatim.openstreetmap.org';
  // Botones de pago: checkout del carrito, pagos acelerados y "Comprar ahora" del producto.
  const BLOCKED_SELECTOR =
    '[name="checkout"], .cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button';
  // Formulario principal de producto (excluye el de cuotas y el sticky).
  const PRODUCT_FORM_SELECTOR =
    'form[action*="/cart/add"][id^="product-form-"]:not([id*="installment"]):not([id*="Sticky"]):not([id*="sticky"])';
  const IGNORE_SELECTOR = 'cart-notification, .cart-notification, [data-shipping-ignore]';

  const WHATSAPP_ICON =
    '<svg class="shipping-checker__whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35ZM12.04 21.5h-.01a9.45 9.45 0 0 1-4.82-1.32l-.35-.21-3.58.94.96-3.49-.23-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.22 4.25-9.47 9.48-9.47 2.53 0 4.91.99 6.7 2.78a9.4 9.4 0 0 1 2.77 6.7c0 5.22-4.25 9.46-9.47 9.46Zm8.06-17.53A11.33 11.33 0 0 0 12.04.63C5.76.63.65 5.74.65 12.02c0 2 .52 3.96 1.52 5.69L.55 23.6l6.04-1.58a11.37 11.37 0 0 0 5.44 1.39h.01c6.28 0 11.39-5.11 11.39-11.39 0-3.04-1.19-5.9-3.33-8.05Z"/></svg>';
  const TRUCK_ICON =
    '<svg class="shipping-checker__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7z"/><circle cx="6.5" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  const storage = {
    get(key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }
  };

  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char]);

  const money = (pesos) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(pesos);

  const toRad = (deg) => (deg * Math.PI) / 180;

  // Distancia en línea recta (km) entre dos coordenadas.
  const haversine = (lat1, lng1, lat2, lng2) => {
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  /*
   * Tabulador. Se trabaja en décimas de km (enteros) para redondear igual que Excel:
   * ROUND(km, 1) y ROUND(km x tarifa, 0). Debe coincidir con tools/generar-zonas-envio.js.
   */
  const quote = (km) => {
    const tenths = Math.round(km * 10 + 1e-6);
    const free = Math.round(CONFIG.freeRadiusKm * 10);
    const limit = Math.round(CONFIG.deliveryLimitKm * 10);
    if (tenths <= free) return { zone: 'free', km: tenths / 10, billedKm: 0, subtotal: 0, iva: 0, cost: 0 };
    if (tenths > limit) return { zone: 'advisor', km: tenths / 10, billedKm: null, subtotal: null, iva: null, cost: null };

    let billedTenths = tenths;
    const band = Math.round(CONFIG.bandKm * 10);
    if (band > 0) billedTenths = Math.min(limit, free + Math.ceil((tenths - free) / band) * band);
    return {
      zone: 'delivery',
      km: tenths / 10,
      billedKm: billedTenths / 10,
      // Tarifa antes de IVA (km x $/km) y total con IVA redondeado a pesos.
      subtotal: Math.round(billedTenths * CONFIG.ratePerKm * 10) / 100,
      iva: Math.round(billedTenths * CONFIG.ratePerKm * (CONFIG.ivaRate || 0) * 10) / 100,
      cost: Math.round((billedTenths * CONFIG.ratePerKm * (1 + (CONFIG.ivaRate || 0))) / 10 + 1e-9)
    };
  };

  // Coordenadas de cada CP (assets/shipping-postal-codes.json), ordenadas por CP.
  // Cada registro: cp(5) + lat*1e4 (6) + |lng|*1e4 (7); en México la longitud siempre es negativa.
  let postalCodesPromise = null;
  const loadPostalCodes = () => {
    if (!postalCodesPromise) {
      postalCodesPromise = fetch(SETTINGS.postalCodesUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`shipping-postal-codes ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          postalCodesPromise = null;
          throw error;
        });
    }
    return postalCodesPromise;
  };

  const lookupPostalCode = (table, cp) => {
    const size = table.recordLength;
    let low = 0;
    let high = table.data.length / size - 1;
    while (low <= high) {
      const mid = (low + high) >> 1;
      const record = table.data.substr(mid * size, size);
      const key = record.slice(0, 5);
      if (key === cp) return { lat: parseInt(record.slice(5, 11), 10) / 1e4, lng: -parseInt(record.slice(11), 10) / 1e4 };
      if (key < cp) low = mid + 1;
      else high = mid - 1;
    }
    return null;
  };

  /*
   * Sucursales y CEDIS vigentes desde la API de gestión (gestion.grupobarradas.com/api/shopify/sucursales).
   * Espera máximo LOCATIONS_TIMEOUT_MS; se guarda 10 min en sessionStorage. Si falla, se usa el respaldo.
   */
  const LOCATIONS_CACHE_KEY = 'barradas:shipping-locations';
  const LOCATIONS_CACHE_MS = 10 * 60 * 1000;
  const LOCATIONS_TIMEOUT_MS = 3000;

  const fromApi = (apiList) => {
    const fallbackById = new Map(FALLBACK_LOCATIONS.filter((l) => l.id != null).map((l) => [l.id, l]));
    return apiList
      .map((s) => {
        const fallback = fallbackById.get(s.id);
        const lat = s.lat != null ? s.lat : fallback && fallback.lat;
        const lng = s.lng != null ? s.lng : fallback && fallback.lng;
        return {
          id: s.id,
          name: s.nombre,
          type: s.tipo === 'cedis' ? 'CEDIS' : 'Sucursal',
          city: [s.ciudad, s.estado].filter(Boolean).join(', '),
          phone: (s.telefonos || [])[0] || '',
          lat,
          lng
        };
      })
      .filter((l) => typeof l.lat === 'number' && typeof l.lng === 'number');
  };

  let locationsPromise = null;
  const getLocations = () => {
    if (locationsPromise) return locationsPromise;
    if (!CONFIG.locationsApiUrl) return (locationsPromise = Promise.resolve(FALLBACK_LOCATIONS));

    try {
      const cached = JSON.parse(sessionStorage.getItem(LOCATIONS_CACHE_KEY));
      if (cached && Date.now() - cached.ts < LOCATIONS_CACHE_MS && cached.list.length) {
        return (locationsPromise = Promise.resolve(cached.list));
      }
    } catch (e) {}

    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = setTimeout(() => controller && controller.abort(), LOCATIONS_TIMEOUT_MS);
    locationsPromise = fetch(CONFIG.locationsApiUrl, { headers: { Accept: 'application/json' }, signal: controller && controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`API de sucursales ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const list = fromApi(data.sucursales || []);
        if (!list.length) throw new Error('API de sucursales sin ubicaciones');
        try {
          sessionStorage.setItem(LOCATIONS_CACHE_KEY, JSON.stringify({ ts: Date.now(), list }));
        } catch (e) {}
        return list;
      })
      .catch((error) => {
        console.warn('shipping-checker: se usa la lista de respaldo de sucursales', error);
        return FALLBACK_LOCATIONS;
      })
      .finally(() => clearTimeout(timer));
    return locationsPromise;
  };

  const nearestByCoords = (locations, lat, lng) => {
    let best = null;
    locations.forEach((location) => {
      const distance = haversine(lat, lng, location.lat, location.lng);
      if (!best || distance < best.distance) best = { location, distance };
    });
    // Se redondea a décimas como en el tabulador.
    if (best) best.distance = Math.round(best.distance * 10) / 10;
    return best;
  };

  const reversePostalCode = async (lat, lng) => {
    try {
      const response = await fetch(`${NOMINATIM}/reverse?format=jsonv2&zoom=16&lat=${lat}&lon=${lng}`, {
        headers: { 'Accept-Language': 'es' }
      });
      if (!response.ok) return '';
      const data = await response.json();
      return (data.address && data.address.postcode) || '';
    } catch (e) {
      return '';
    }
  };

  // Con CP se usan sus coordenadas del catálogo; con GPS sin CP, las del navegador.
  const resolveCheck = async (check) => {
    const [locations, coords] = await Promise.all([
      getLocations(),
      check.cp ? loadPostalCodes().then((table) => lookupPostalCode(table, check.cp)) : Promise.resolve(null)
    ]);
    if (coords) return nearestByCoords(locations, coords.lat, coords.lng);
    if (check.source === 'cp') return null;
    if (typeof check.lat === 'number' && typeof check.lng === 'number') return nearestByCoords(locations, check.lat, check.lng);
    return null;
  };

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Navegación centralizada (se puede sustituir en pruebas).
  const api = {
    quote,
    config: CONFIG,
    navigate: (url) => {
      window.location.href = url;
    },
    reload: () => window.location.reload(),
    retryDelay: 6000
  };
  window.BarradasShipping = api;

  const originLabel = (location) => `${escapeHtml(location.type || 'Sucursal')} ${escapeHtml(location.name)}`;

  let uid = 0;

  class ShippingChecker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.uid = ++uid;
      this.render();

      this.form = this.querySelector('[data-shipping-form]');
      this.input = this.querySelector('[data-shipping-cp]');
      this.geoButton = this.querySelector('[data-shipping-geo]');
      this.resultEl = this.querySelector('[data-shipping-result]');

      this.onExternalUpdate = this.onExternalUpdate.bind(this);
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.geoButton.addEventListener('click', this.onGeo.bind(this));
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 5);
      });
      document.addEventListener('shipping-checker:update', this.onExternalUpdate);

      const saved = storage.get(STORAGE_KEY);
      if (saved && Date.now() - saved.ts < MAX_AGE_MS) {
        this.apply(saved, false);
      } else {
        this.toggleCheckout('pending');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shipping-checker:update', this.onExternalUpdate);
      this.initialized = false;
    }

    render() {
      const inputId = `ShippingCheckerCP-${this.uid}`;
      this.classList.add('shipping-checker', 'db');
      this.innerHTML = `
        <div class="shipping-checker__header flex align-center">
          ${TRUCK_ICON}
          <p class="shipping-checker__title font-heading-bold margin0">${escapeHtml(CONFIG.title)}</p>
        </div>
        ${CONFIG.hint ? `<p class="shipping-checker__hint text-small margin0">${escapeHtml(CONFIG.hint)}</p>` : ''}
        <form class="shipping-checker__form flex" data-shipping-form novalidate>
          <label class="visually-hidden" for="${inputId}">Código postal</label>
          <input id="${inputId}" class="shipping-checker__input field__input" type="text" inputmode="numeric"
            autocomplete="postal-code" maxlength="5" pattern="[0-9]{5}" placeholder="Código postal" data-shipping-cp required>
          <button type="submit" class="shipping-checker__submit button button--primary"><span>Calcular</span></button>
        </form>
        <button type="button" class="shipping-checker__geo link underlined-link unstyled-button text-small" data-shipping-geo>
          Usar mi ubicación actual
        </button>
        <div class="shipping-checker__result" data-shipping-result role="status" aria-live="polite" hidden></div>`;
    }

    async onSubmit(event) {
      event.preventDefault();
      const cp = this.input.value.trim();
      if (!/^\d{5}$/.test(cp)) {
        this.renderMessage('error', 'Escribe un código postal válido de 5 dígitos.');
        return;
      }

      this.setLoading(true);
      try {
        await Promise.all([loadPostalCodes(), getLocations()]);
        this.setLoading(false);
        this.publish({ cp, source: 'cp', ts: Date.now() });
      } catch (e) {
        this.setLoading(false);
        this.renderMessage('error', 'No pudimos calcular tu envío en este momento. Intenta de nuevo.');
      }
    }

    onGeo() {
      if (!navigator.geolocation) {
        this.renderMessage('error', 'Tu navegador no permite obtener la ubicación. Escribe tu código postal.');
        return;
      }

      this.setLoading(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude: lat, longitude: lng } = position.coords;
          const cp = await reversePostalCode(lat, lng);
          this.setLoading(false);
          this.publish({ cp, lat, lng, source: 'gps', ts: Date.now() });
        },
        () => {
          this.setLoading(false);
          this.renderMessage('error', 'No pudimos obtener tu ubicación. Revisa los permisos o escribe tu código postal.');
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
      );
    }

    // Guarda la consulta y avisa a los demás widgets de la página (producto y carrito).
    publish(check) {
      storage.set(STORAGE_KEY, check);
      document.dispatchEvent(new CustomEvent('shipping-checker:update', { detail: { check, source: this } }));
      this.apply(check, true);
    }

    onExternalUpdate(event) {
      if (event.detail.source !== this) this.apply(event.detail.check, false);
    }

    async apply(check, saveToCart) {
      if (check.cp) this.input.value = check.cp;
      this.lastResult = null;
      this.lastQuote = null;

      let result;
      try {
        result = await resolveCheck(check);
      } catch (e) {
        this.renderMessage('error', 'No pudimos calcular tu envío en este momento. Intenta de nuevo.');
        this.toggleCheckout('pending');
        return;
      }

      const shipping = result ? quote(result.distance) : { zone: 'advisor', km: null, billedKm: null, subtotal: null, iva: null, cost: null };
      this.lastResult = result;
      this.lastQuote = shipping;

      this.renderQuote(check, result, shipping);
      const states = { free: 'allowed', delivery: 'delivery', advisor: 'advisor' };
      this.toggleCheckout(states[shipping.zone]);
      if (saveToCart) this.saveCartAttributes(check, result, shipping);
    }

    renderQuote(check, result, shipping) {
      if (shipping.zone === 'free') {
        this.renderHtml(
          'free',
          `<p class="shipping-checker__status font-body-bold margin0">¡Envío gratis!</p>
           <p class="text-small margin0">Tu pedido se entrega desde ${originLabel(result.location)}.</p>`
        );
        return;
      }

      if (shipping.zone === 'delivery') {
        const bandNote = CONFIG.bandKm > 0 ? ` Tarifa por rangos de ${CONFIG.bandKm} km.` : '';
        this.renderHtml(
          'delivery',
          `<p class="shipping-checker__status font-body-bold margin0">Envío: ${money(shipping.cost)}${CONFIG.ivaRate ? ' <span class="shipping-checker__iva">IVA incluido</span>' : ''}</p>
           <p class="text-small margin0">Tu código postal está aproximadamente a ${shipping.km.toFixed(1)} km de ${originLabel(result.location)}, la más cercana.</p>
           <p class="text-small margin0">Un asesor confirmará tu pedido y el cobro del envío por WhatsApp.</p>
           ${this.advisorHtml()}
           <p class="shipping-checker__footnote margin0">*Distancia calculada en línea recta desde la sucursal o CEDIS más cercano.${bandNote}</p>`
        );
        return;
      }

      const intro = result
        ? '<p class="shipping-checker__status font-body-bold margin0">Cotiza tu envío con un asesor</p><p class="text-small margin0">Tu código postal está fuera de nuestra zona de entrega directa. Un asesor te cotizará el envío por fletera.</p>'
        : `<p class="shipping-checker__status font-body-bold margin0">No encontramos el código postal ${escapeHtml(check.cp)}</p><p class="text-small margin0">Revisa que esté bien escrito, usa tu ubicación actual o cotiza el envío con un asesor.</p>`;
      this.renderHtml('advisor', intro + this.advisorHtml());
    }

    advisorHtml() {
      if (!CONFIG.whatsapp) {
        console.warn('shipping-checker: falta "whatsapp" en snippets/shipping-checker-config.liquid');
        return '';
      }
      return `<a class="shipping-checker__whatsapp button button--primary w100" href="https://wa.me/${escapeHtml(CONFIG.whatsapp)}" target="_blank" rel="noopener" data-shipping-whatsapp><span class="shipping-checker__whatsapp-label">${WHATSAPP_ICON}${this.lastQuote && this.lastQuote.zone === 'delivery' ? 'Comprar con un asesor' : 'Cotizar envío con un asesor'}</span></a>`;
    }

    renderMessage(state, message) {
      this.renderHtml(state, `<p class="text-small margin0">${escapeHtml(message)}</p>`);
    }

    renderHtml(state, html) {
      this.resultEl.className = `shipping-checker__result shipping-checker__result--${state}`;
      this.resultEl.innerHTML = html;
      this.resultEl.hidden = false;
      const whatsapp = this.resultEl.querySelector('[data-shipping-whatsapp]');
      if (whatsapp) whatsapp.addEventListener('click', this.onWhatsappClick.bind(this));
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      this.form.querySelector('button').disabled = isLoading;
      this.geoButton.disabled = isLoading;
      if (isLoading) this.renderMessage('loading', 'Calculando…');
    }

    /*
     * Solo se paga en línea con envío gratis. Con costo (entrega Barradas) o fuera de zona,
     * el vendedor cierra la venta y cobra el envío por WhatsApp.
     * El bloqueo va en la sección (data-shipping-blocked) para sobrevivir a re-renders de los botones.
     * state: 'pending' | 'delivery' | 'advisor' | 'allowed'
     */
    toggleCheckout(state) {
      const scope = this.closest('.shopify-section') || this.parentElement;
      if (!scope) return;
      const isBlocked = state !== 'allowed';
      scope.toggleAttribute('data-shipping-blocked', isBlocked);

      // No se usa `disabled` para que el clic llegue al listener y lleve al cotizador.
      scope.querySelectorAll(BLOCKED_SELECTOR).forEach((el) => {
        el.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');
      });

      const messages = {
        pending: 'Calcula tu envío con tu código postal para continuar con tu compra.',
        delivery: 'Tu envío tiene costo: completa tu pedido con un asesor por WhatsApp.',
        advisor: 'Para completar tu pedido, cotiza el envío con un asesor.'
      };
      let note = this.querySelector('[data-shipping-checkout-note]');
      if (!isBlocked) {
        if (note) note.remove();
        return;
      }
      if (!note) {
        note = document.createElement('p');
        note.className = 'shipping-checker__checkout-note text-small margin0';
        note.setAttribute('data-shipping-checkout-note', '');
        this.appendChild(note);
      }
      note.textContent = messages[state];
    }

    focusForValidation() {
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const note = this.querySelector('[data-shipping-checkout-note]');
      if (note) {
        note.classList.remove('is-flashing');
        void note.offsetWidth;
        note.classList.add('is-flashing');
      }
      if (!this.lastResult) this.input.focus({ preventScroll: true });
    }

    whatsappUrl(lines) {
      return `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(lines.filter(Boolean).join('\n'))}`;
    }

    locationLines() {
      const saved = storage.get(STORAGE_KEY);
      const lines = [];
      if (saved && saved.cp) lines.push(`Código postal de entrega: ${saved.cp}`);
      if (this.lastResult) {
        const { location, distance } = this.lastResult;
        lines.push(`Sucursal más cercana: ${location.name} (${location.city}) - ${distance.toFixed(1)} km aprox.`);
      }
      // Costo del tabulador, para que el vendedor lo cobre al cerrar la venta.
      if (this.lastQuote && this.lastQuote.zone === 'delivery') {
        lines.push(`Costo de envío: ${money(this.lastQuote.cost)}${CONFIG.ivaRate ? ' IVA incluido' : ''}`);
      } else if (this.lastQuote && this.lastQuote.zone === 'advisor' && this.lastResult) {
        lines.push('Fuera de la zona de entrega directa: cotizar envío por fletera.');
      }
      return lines.join('\n');
    }

    // Con costo de envío el cliente ya quiere comprar; fuera de zona, cotizar la fletera.
    wantsTo(target) {
      const what = target === 'product' ? 'este producto' : 'mi carrito';
      return this.lastQuote && this.lastQuote.zone === 'delivery'
        ? `comprar ${what} con envío a domicilio`
        : `cotizar el envío de ${what}`;
    }

    // Producto: toma la variante y cantidad seleccionadas en el formulario al momento del clic.
    productMessage() {
      const product = SETTINGS.product;
      if (!product) return ['Hola, quiero cotizar un envío.', this.locationLines()];

      const scope = this.closest('.shopify-section') || document;
      const form = scope.querySelector(PRODUCT_FORM_SELECTOR) || scope.querySelector('form[action*="/cart/add"]');
      const variantInput = form && form.querySelector('[name="id"]');
      const quantityInput = scope.querySelector('input[name="quantity"]');
      const variantId = Number(variantInput && variantInput.value) || product.selectedVariantId;
      const variant = product.variants.find((v) => v.id === variantId) || product.variants[0];
      const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

      const name = product.hasOnlyDefaultVariant ? product.title : `${product.title} (${variant.title})`;
      return [
        `Hola, quiero ${this.wantsTo('product')}:`,
        `• ${quantity} x ${name}${variant.sku ? ` - Modelo: ${variant.sku}` : ''}`,
        `${product.url}?variant=${variant.id}`,
        this.locationLines()
      ];
    }

    // Carrito: lee el carrito actual para incluir exactamente lo que el cliente tiene.
    async cartMessage() {
      const response = await fetch(`${SETTINGS.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      const format = (cents) =>
        new Intl.NumberFormat('es-MX', { style: 'currency', currency: cart.currency || 'MXN' }).format(cents / 100);

      const items = cart.items.map((item) => {
        const variant = item.variant_title && !/default title/i.test(item.variant_title) ? ` (${item.variant_title})` : '';
        const sku = item.sku ? ` - Modelo: ${item.sku}` : '';
        return `• ${item.quantity} x ${item.product_title}${variant}${sku}`;
      });

      return [`Hola, quiero ${this.wantsTo('cart')}:`, ...items, `Total: ${format(cart.total_price)}`, this.locationLines()];
    }

    async onWhatsappClick(event) {
      event.preventDefault();
      const link = event.currentTarget;

      if (this.dataset.context === 'product') {
        window.open(this.whatsappUrl(this.productMessage()), '_blank', 'noopener');
        return;
      }

      // Se abre la ventana antes del fetch para que el navegador no la bloquee.
      const popup = window.open('', '_blank');
      let url;
      try {
        url = this.whatsappUrl(await this.cartMessage());
      } catch (e) {
        url = this.whatsappUrl([`Hola, quiero ${this.wantsTo('cart')}.`, this.locationLines()]);
      }
      if (popup) {
        popup.opener = null;
        popup.location.href = url;
      } else {
        window.location.href = url;
      }
      link.blur();
    }

    // Deja la cotización en el pedido (atributos del carrito) para que el equipo la vea.
    saveCartAttributes(check, result, shipping) {
      if (!SETTINGS.cartUpdateUrl) return;
      const zoneLabels = { free: 'Gratis', delivery: 'Entrega Barradas', advisor: 'Fletera / asesor' };
      fetch(`${SETTINGS.cartUpdateUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Envío - CP': check.cp || 'GPS',
            'Envío - Sucursal cercana': result ? result.location.name : 'No encontrada',
            'Envío - Distancia (km)': result ? result.distance.toFixed(1) : '',
            'Envío - Zona': zoneLabels[shipping.zone],
            'Envío - Costo': shipping.zone === 'delivery' ? money(shipping.cost) : shipping.zone === 'free' ? '$0' : 'Cotizar con asesor',
            // Atributo de la versión anterior; un valor vacío lo elimina del carrito.
            'Envío - Resultado': ''
          }
        })
      }).catch(() => {});
    }
  }

  customElements.define('shipping-checker', ShippingChecker);

  /*
   * Inserción automática: junto a "Pagar pedido" (carrito y cart drawer) y después del
   * formulario principal de producto. Un MutationObserver vuelve a insertarlo cuando el
   * tema re-renderiza el carrito.
   */
  const createChecker = (context) => {
    const el = document.createElement('shipping-checker');
    el.dataset.context = context;
    return el;
  };

  const mountCart = () => {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
      if (button.closest(IGNORE_SELECTOR) || button.type === 'hidden') return;
      const anchor = button.closest('form') || button;
      const section = anchor.closest('.shopify-section') || anchor.parentElement;
      if (!section || section.querySelector('shipping-checker[data-context="cart"]')) return;
      anchor.parentElement.insertBefore(createChecker('cart'), anchor);
    });
  };

  const mountProduct = () => {
    if (!SETTINGS.product) return;
    if (document.querySelector('shipping-checker[data-context="product"]')) return;
    const form =
      document.querySelector(`.shopify-section[id*="__main"] ${PRODUCT_FORM_SELECTOR}`) ||
      document.querySelector(PRODUCT_FORM_SELECTOR);
    if (!form || form.closest(IGNORE_SELECTOR)) return;
    const anchor = form.closest('product-form') || form;
    anchor.insertAdjacentElement('afterend', createChecker('product'));
  };

  let scheduled = false;
  const mount = () => {
    scheduled = false;
    mountCart();
    mountProduct();
  };
  const scheduleMount = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(mount);
  };

  mount();
  new MutationObserver(scheduleMount).observe(document.body, { childList: true, subtree: true });

  /*
   * Bloqueo de compra y precarga del CP en el checkout.
   */
  const blockedScope = (el) => {
    const button = el && el.closest && el.closest(BLOCKED_SELECTOR);
    return button && button.closest('[data-shipping-blocked]');
  };

  const stopPurchase = (event, scope) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const checker = scope.querySelector('shipping-checker');
    if (checker) checker.focusForValidation();
  };

  let checkingOut = false;

  // "Pagar pedido": deja la línea de envío correcta en el carrito y abre el checkout con el CP capturado.
  const goToCheckout = async (event) => {
    const button = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');
    const saved = storage.get(STORAGE_KEY);
    if (!button || !saved) return;

    const form = button.form || button.closest('form');
    if (form && !form.checkValidity()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    button.setAttribute('aria-busy', 'true');

    const checker = (button.closest('.shopify-section') || document).querySelector('shipping-checker');
    try {
      // Solo se paga en línea con envío gratis; con costo, el vendedor cierra la venta por WhatsApp.
      const result = await resolveCheck(saved);
      const shipping = result ? quote(result.distance) : { zone: 'advisor' };
      if (shipping.zone !== 'free') throw new Error(shipping.zone);

      const params = new URLSearchParams({ 'checkout[shipping_address][country]': 'MX' });
      if (saved.cp) params.set('checkout[shipping_address][zip]', saved.cp);
      api.navigate(`${root()}checkout?${params}`);
      // Si la navegación no ocurre (cancelada por el navegador), se reactiva el botón.
      setTimeout(() => {
        checkingOut = false;
        button.removeAttribute('aria-busy');
      }, api.retryDelay);
    } catch (error) {
      checkingOut = false;
      button.removeAttribute('aria-busy');
      if (checker) checker.focusForValidation();
    }
  };

  // Al volver con el botón "atrás" desde el checkout, la página puede salir del caché (bfcache).
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) checkingOut = false;
  });

  // Fase de captura: corre antes que los handlers del tema y de Shopify.
  document.addEventListener(
    'click',
    (event) => {
      const scope = blockedScope(event.target);
      if (scope) {
        stopPurchase(event, scope);
        return;
      }
      goToCheckout(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const scope = blockedScope(event.submitter);
      if (scope) {
        stopPurchase(event, scope);
        return;
      }
      // Envío con Enter dentro del formulario del carrito: mismo flujo que el clic.
      if (event.submitter && event.submitter.matches('[name="checkout"]')) goToCheckout({ target: event.submitter, preventDefault: () => event.preventDefault(), stopImmediatePropagation: () => event.stopImmediatePropagation() });
    },
    true
  );


})();
